export const faqData = [
  {
    id: 1,
    question: "What is a Credit Card EMI Calculator?",
    answer:
      "A credit card EMI calculator helps you estimate monthly payments, total interest, and processing fees for converting credit card transactions into EMIs.",
  },
  {
    id: 2,
    question: "How Can I Convert a Credit Card Transaction to EMIs?",
    answer:
      "Most credit card issuers allow EMI conversions for eligible transactions. You can opt for this feature through your bank’s app, website, or customer service.",
  },
  {
    id: 3,
    question: "What Are the Key Charges for EMI Conversions?",
    answerList: [
      {
        head: "Processing Fee: ",
        info: "Typically 1%-3% of the transaction amount.",
      },
      {
        head: "Interest Rate: ",
        info: "Varies between 12%-24% per annum.",
      },
      {
        head: "Prepayment Fee: ",
        info: "Some issuers charge a fee for early repayment.",
      },
    ],
  },
  {
    id: 4,
    question: "Can I Use the EMI Option for Any Transaction?",
    answer:
      "Not all transactions are eligible for EMI conversion. Eligibility depends on the transaction amount and the terms set by your credit card issuer.",
  },
  {
    id: 5,
    question: "What is a Balance Transfer on Credit Cards?",
    answer:
      "A balance transfer allows you to move your outstanding credit card balance to another card or loan with a lower interest rate, reducing your overall repayment burden.",
  },
  {
    id: 6,
    question: "Is It Better to Use Credit Card EMIs or a Personal Loan?",
    answerList: [
      {
        head: "Credit Card EMIs: ",
        info: "Convenient for small to medium-sized purchases, but interest rates are higher.",
      },
      {
        head: "Personal Loan: ",
        info: "Better for larger amounts due to lower interest rates and longer repayment tenures.",
      },
    ],
  },
  {
    id: 7,
    question: "Are There Any Alternatives to Credit Card EMIs?",
    answer: "Yes, alternatives include:",
    answerList: [
      {
        info: " Balance Transfers to a lower-interest credit card or personal loan.",
      },
      {
        info: "Zero-cost EMIs offered during promotional periods by merchants and banks.",
      },
    ],
  },
];
